export type Testimonial = {
  name: string;
  location: string;
  text: string;
};

export const parentTestimonials: Array<Testimonial> = [
  {
    name: 'Kailene K.',
    location: 'Rochester, NY',
    text: 'My son loves to be outdoors and hiring a sitter with Sittercity allowed him to play all day. When I got home he was ready for dinner and a bath–he slept well that night!',
  },
  {
    name: 'Jenny',
    location: 'Cleveland, OH',
    text: 'Being able to hand over tasks and take things off my plate has helped me breathe a lot easier. She is not only here for my kids, but she’s here to help me out too.',
  },
  {
    name: 'Hannah P.',
    location: 'Savannah, GA',
    text: 'Finding a sitter on our vacation with Sittercity, gave us the flexibility to enjoy some things as a couple without our toddler. It made such a difference.',
  },
  {
    name: 'Kristen P.',
    location: 'Chicago, IL',
    text: 'Not only does my Sittercity nanny allow me to get stuff done, but I also get some much-needed time for myself.',
  },
  {
    name: 'Amanda P.',
    location: 'Seattle, WA',
    text: 'My sitter came prepared and was very communicative with us. She displayed a level of professionalism you want when someone is taking care of your child.',
  },
];
